import type { FormFields, FormErrors } from '../../../../../formFields'

import { Password } from '@workwave-tidal/form-ui'

import { useTexts } from './useTexts'

export function OldPassword() {
  const texts = useTexts()

  return (
    <Password<'oldPassword', FormFields, FormErrors>
      name="oldPassword"
      label={texts.oldPassword}
      autoFocus
      validateOn="blur focus change"
    />
  )
}
